module.exports = __webpack_public_path__ + "img/tower_defensive.899f0911.svg";